import React from 'react';
import { Card } from 'react-bootstrap';
import cardImage from '../../assets/hhie-card.jpg';
import '../../styles/HHIECard.css';

export function HHIECard(props) {
    return (
        <div 
            className="card-container"
            style={{
                position: 'absolute', 
                left: '50%', 
                top: '50%',
                transform: 'translate(-50%, -60%)'
                ,maxWidth:'850px'
            }}
        >
            <Card className="HHIE-card">
                <Card.Img variant="top" src={cardImage} />
                <Card.Body>
                {props.children}
                </Card.Body>
            </Card>
        </div>
    );
}
